import clsx from 'clsx';
import { OrderStatusType } from '../../../types/order/orderType';

const statusStyles: Record<OrderStatusType, string> = {
  pending:
    'border-[rgba(180,83,9,1)] text-[rgba(180,83,9,1)] bg-[rgba(255,251,235,1)]',

  marked_as_packed:
    'border-[rgba(29,78,216,1)] text-[rgba(29,78,216,1)] bg-[rgba(239,246,255,1)]',

  shipped:
    'border-[rgba(3,105,161,1)] text-[rgba(3,105,161,1)] bg-[rgba(240,249,255,1)]',

  delivered:
    'border-[rgba(21,128,61,1)] text-[rgba(21,128,61,1)] bg-[rgba(240,253,244,1)]',

  successful:
    'border-[rgba(5,150,105,1)] text-[rgba(5,150,105,1)] bg-[rgba(236,253,245,1)]',

  settled:
    'border-[rgba(79,70,229,1)] text-[rgba(79,70,229,1)] bg-[rgba(238,242,255,1)]',

  refunded:
    'border-[rgba(8,145,178,1)] text-[rgba(8,145,178,1)] bg-[rgba(236,254,255,1)]',

  cancelled:
    'border-[rgba(220,38,38,1)] text-[rgba(220,38,38,1)] bg-[rgba(254,242,242,1)]',

  failed:
    'border-[rgba(185,28,28,1)] text-[rgba(185,28,28,1)] bg-[rgba(254,242,242,1)]',

  lost: 'border-[rgba(185,28,28,1)] text-[rgba(185,28,28,1)] bg-[rgba(254,242,242,1)]',
};

const orderStatusThemeStyle = (status: OrderStatusType) =>
  clsx('border', statusStyles[status] ?? '');

export default orderStatusThemeStyle;
